import { MatPaginatorIntl } from '@angular/material/paginator';

const icelandicRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) {
        return `0 af ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `Birti færslur ${(startIndex + 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} til ${endIndex.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} af ${length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} færslum`;
};

export function getIcelandicPaginatorIntl() {
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = 'Hámarksfjöldi færslna á síðu:';
    paginatorIntl.nextPageLabel = 'Næsta síða';
    paginatorIntl.previousPageLabel = 'Fyrri síða';
    paginatorIntl.lastPageLabel = 'Aftasta síða';
    paginatorIntl.firstPageLabel = 'Fremsta síða';
    paginatorIntl.getRangeLabel = icelandicRangeLabel;
    return paginatorIntl;
}
